export default {"src":"/_next/static/media/paper-plane.7ac02553.svg","height":22,"width":22};